import React, { useContext, useEffect } from "react";
import Context from "../../../../context";
import { useLocation, useNavigate } from "react-router-dom";
import '../BackendUnavailable/index.scss';
import Button from "../../Buttons/Button";

const NotFoundScreen = ({ isDocument }) => {
  const { t, itin } = useContext(Context);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.includes("directory")) {
      const directoryPath = pathname.replace(/(\/directory)(\/.*)?$/, '$1');
      navigate(directoryPath, { replace: true });
    }
  }, [navigate, pathname]);

  const goToHome = () => {
    navigate(`/${itin.localData.urlKey}`);
  };

  return (
    <div className="wrapper">
      <div className="substrate">
        <div className="headline">
          {isDocument ? "Whoops! Page Not Found" : t("not_found")}
        </div>
        <div className="short-info">
          To continue, please click the button below to go to the main page.
        </div>
        <Button
          className="contact-button"
          outline={false}
          onClick={goToHome}
        >
          Go to Home Page
        </Button>
      </div>
    </div>
  );
};

export default NotFoundScreen;